import { TreeGridColumn } from "../types"
import { ReportedHoursVisibleColumnName } from "./types"

export function makeColumns({ columnOrder, visibleColumns, labels }: MakeColumnsProps): TreeGridColumn[] {
  const dateColumn = {
    Name: "date",
    Type: "Date",
    Width: 140,
    CanEdit: 0,
    Visible: visibleColumns.includes("date"),
    header: labels.date,
  }

  const projectOrTaskColumn = {
    Name: "projectOrTask",
    Type: "Html",
    Width: 280,
    MinWidth: 220,
    CanEdit: 0,
    CanSort: 0,
    Visible: visibleColumns.includes("projectOrTask"),
    SearchNames: "projectOrTask,projectOrTaskSearchValue",
    header: labels.projectTask,
  }

  const projectColumn = {
    Name: "project",
    Visible: 0,
    CanHide: 0,
    CanEdit: 0,
    CanExport: 0,
    CanPrint: 0,
  }

  const panelColumn = {
    Name: "Panel",
    CanHide: 0,
    CanExport: 0,
    CanPrint: 0,
    CanEdit: 0,
    Visible: 0,
  }

  const customerColumn = {
    Name: "customer",
    Width: 180,
    MinWidth: 140,
    CanEdit: 0,
    Visible: visibleColumns.includes("customer"),
    header: labels.customer,
  }

  const descriptionColumn = {
    Name: "description",
    Type: "Lines",
    RelWidth: 1,
    MinWidth: 220,
    CanEdit: 0,
    CanSort: 0,
    Visible: visibleColumns.includes("description"),
    header: labels.description,
  }

  const startedColumn = {
    Name: "started",
    Width: 96,
    CanEdit: 0,
    Visible: visibleColumns.includes("started"),
    header: labels.started,
  }

  const finishedColumn = {
    Name: "finished",
    Width: 96,
    CanEdit: 0,
    Visible: visibleColumns.includes("finished"),
    header: labels.finished,
  }

  const hoursColumn = {
    Name: "hours",
    Width: 96,
    CanEdit: 0,
    Visible: visibleColumns.includes("hours"),
    header: labels.hours,
    Formula: "Grids.FormatTotalReportedHours(sum('durationInDecimalHours', '4'))",
    Class: "reported-hours-total-value",
  }

  const statusColumn = {
    Name: "status",
    Width: 140,
    MinWidth: 120,
    CanEdit: 0,
    Visible: visibleColumns.includes("status"),
    header: labels.status,
  }

  const durationInDecimalHoursColumn = {
    Name: "durationInDecimalHours",
    Visible: 0,
    CanEdit: 0,
    CanExport: 0,
    CanPrint: 0,
    CanHide: 0,
  }

  const workerColumn = {
    Name: "worker",
    Width: 180,
    MinWidth: 140,
    CanEdit: 0,
    Visible: visibleColumns.includes("worker"),
    header: labels.worker,
  }

  const columnsByName: Record<ReportedHoursVisibleColumnName, TreeGridColumn> = {
    date: dateColumn,
    projectOrTask: projectOrTaskColumn,
    description: descriptionColumn,
    started: startedColumn,
    finished: finishedColumn,
    hours: hoursColumn,
    status: statusColumn,
    worker: workerColumn,
    customer: customerColumn,
    durationInDecimalHours: durationInDecimalHoursColumn,
  }

  return columnOrder.map((columnName) => columnsByName[columnName]).concat([projectColumn, panelColumn])
}

type MakeColumnsProps = {
  visibleColumns: ReportedHoursVisibleColumnName[]
  columnOrder: ReportedHoursVisibleColumnName[]
  labels: ReportedHoursColumnLabels
}

export type ReportedHoursColumnLabels = {
  date: string
  projectTask: string
  customer: string
  description: string
  started: string
  finished: string
  hours: string
  status: string
  worker: string
}
